import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import TablaEditarProductos from "./TablaEditarPromocion";

const HomePromocion = () => {
    const { listaPromociones, setListaPromociones, ActualizarLista } = useContextEmpleado();
    const datos = {
        titulo: {
            titulo: "Edicion promociones",
            url: "/app/admin/promociones/editar",
            tituloUrl: "Menu Promociones",
            nombreUrl: "Inicio ",
        },
    };

    return (
        <Page datos={datos}>
            <Card>
                <TablaEditarProductos datos={listaPromociones}></TablaEditarProductos>
            </Card>
        </Page>
    );
}

export default HomePromocion;